var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bar',{ref:"chart",attrs:{"height":_vm.height,"chart-data":_vm.data,"plugins":_vm.plugins,"chart-options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }